import { render, staticRenderFns } from "./DocumentiDeiContratti.vue?vue&type=template&id=8d86c434&"
import script from "./DocumentiDeiContratti.vue?vue&type=script&lang=js&"
export * from "./DocumentiDeiContratti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports